export default "__VITE_ASSET__D$dog1j___"